import React from 'react';
import Button from './Button';

const MyButton: React.FC = () => {
  const handleClick = () => {
    window.location.href = 'https://ppobindo.com/getflix/game/pindochess/index.php' target='_parent'; // Replace with your desired URL
  };

  return (
    <Button onClick={handleClick}>
      Main Online
    </Button>
  );
};

export default MyButton;